import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { switchMap, Observable, ReplaySubject, map, take, combineLatest } from 'rxjs';
import { ChargepointsApiService, Chargepoint } from '../../api/chargepoints-api.service';
import { CommonModule } from '@angular/common';
import { OcppChargepointPageComponent } from './ocpp-chargepoint-page/ocpp-chargepoint-page.component';
import { RefreshService } from '../../components/common/refresh-widget/refresh.service';
import { OkechargeChargepointPageComponent } from './okecharge-chargepoint-page/okecharge-chargepoint-page.component';
import { IvyChargepointPageComponent } from './ivy-chargepoint-page/ivy-chargepoint-page.component';

@Component({
  selector: 'app-chargepoint-page',
  templateUrl: './chargepoint-page.component.html',
  styleUrls: ['./chargepoint-page.component.scss'],
  imports: [
    CommonModule,
    OcppChargepointPageComponent,
    OkechargeChargepointPageComponent,
    IvyChargepointPageComponent,
  ],
  standalone: true
})
export class ChargepointPageComponent {
  public chargepoint$: Observable<Chargepoint>;
  public chargepointId$: ReplaySubject<string> = new ReplaySubject<string>(1);

  constructor(private route: ActivatedRoute, private chargepointsApiService: ChargepointsApiService, private refreshService: RefreshService) {
    this.chargepoint$ = combineLatest([
      this.route.params.pipe(
        map(params => params['id']),
        take(1)
      ),
      this.refreshService.refreshTrigger
    ]).pipe(
      switchMap(([id]) => this.chargepointsApiService.getChargepoint(id))
    );
  }

  public refresh() {
    this.refreshService.trigger();
  }
}
